export default "__VITE_ASSET__f03b7cf4__"